import React from 'react';
import {Box, Button, Chip, Typography} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TypologieLavageBadge from '../../layout/TypologieLavageBadge.js';
import {Eyebrow, Picto} from './primitives.js';
import {helper} from '../../../../utils/helper';

const Col = ({label, value}) => (
    <Box sx={{minWidth: 0}}>
        <Eyebrow sx={{mb: 0.25}}>{label}</Eyebrow>
        <Typography sx={{fontWeight: 700, color: '#2D333B', overflowWrap: 'anywhere'}}>{value ?? '—'}</Typography>
    </Box>
);

/**
 * Bandeau verdict pleine largeur (handoff 2a / 4a / 4b2 / 4c).
 * Gauche (flexible) : pastille 52 px + titre 24/800, sous-ligne « n / N bacs » (ou raison) + badge
 * typologie + pilule prestation, puis la ligne Passage / Opérateur / Tournée (qui peut passer à la
 * ligne sans pousser le bouton). Droite (fixe) : bouton « Fiche PDF ».
 */
function VerdictBanner({verdict, passage, isClient, onPDFClick}) {
    return (
        <Box sx={{
            background: verdict.gradient, border: `1px solid ${verdict.border}`, borderRadius: '16px',
            p: {xs: 2, md: 3}, display: 'flex', alignItems: 'flex-start', gap: {xs: 2, md: 3},
        }}>
            <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 2, flex: '1 1 auto', minWidth: 0}}>
                <Box sx={{width: 52, height: 52, borderRadius: '50%', bgcolor: verdict.dot, color: '#fff', flex: 'none',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 6px rgba(16,46,105,.12)'}}>
                    <Picto name={verdict.icon} sx={{fontSize: 30}}/>
                </Box>
	            <Box>
		            <Typography component="h2" sx={{fontSize: 24, fontWeight: 800, lineHeight: 1.15, color: verdict.titleColor}}>
			            {verdict.title}
		            </Typography>
		            <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5, mt: 0.5, flexWrap: 'wrap'}}>
			            <Typography sx={{fontWeight: 600, color: '#5A6470'}}>{verdict.subline}</Typography>
			            {passage.typologie && <TypologieLavageBadge typologie={passage.typologie} small/>}
			            {verdict.partiel && passage.prestation && (
			              <Chip size="small" label={passage.prestation} sx={{bgcolor: '#fff', border: '1px solid #CFE2A0', fontWeight: 600}}/>
			            )}
		            </Box>
	            </Box>
	            <Box sx={{display: 'flex', flexWrap: 'wrap', gap: {xs: 2, md: 4}, rowGap: 1}}>
		            <Col label="Passage" value={passage.dateEvenement ? helper.getFormattedDatetime(passage.dateEvenement) : null}/>
		            {!isClient && <Col label="Opérateur" value={passage.operateur}/>}
		            <Col label="Tournée" value={passage.tournee}/>
	            </Box>
            </Box>

            <Button variant="contained" onClick={onPDFClick} startIcon={<PictureAsPdfIcon/>}
                    sx={{borderRadius: 999, bgcolor: '#0F2D69', fontWeight: 700, px: 2.5, flex: 'none', whiteSpace: 'nowrap',
                        '&:hover': {bgcolor: '#1B3E86'}}}>
                Fiche PDF
            </Button>
        </Box>
    );
}

export default VerdictBanner;
